import { render, staticRenderFns } from "./BuyBoxFilterNew.vue?vue&type=template&id=4ca0b6a8&scoped=true"
import script from "./BuyBoxFilterNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxFilterNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxFilterNew.vue?vue&type=style&index=0&id=4ca0b6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca0b6a8",
  null
  
)

export default component.exports